// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a16aa881","455":"58ebb6e4","488":"c46bd749"}[chunkId] + ".chunk.js";
};